import { isAdmin, isSale, isVAFull } from 'utils/util';
import { RecordManagerTab } from './RecordManagerTab';
import { useEffect, useState, useContext } from 'react';
import { InvestorManager } from './InvestorManager';
import { PropertyManager } from './PropertyManager';
import { HoldingCompanyManager } from './HoldingCompanyManager';
import { FundManager } from './FundManager';
import { InvestmentManager } from './InvestmentManager';
import { isPhoneSize } from 'utils/util';
import { AccountManager } from './AccountManager';
import { GlobalContext } from 'GlobalContext';
import { PortfolioSumary } from 'pages/PortfolioSumary/PortfolioSumary';
import { Admin } from 'pages/ManageRecordAdmin/Admin';

export function RecordManager(props) {
    const { manageRecordTab, setManageRecordTab } = useContext(GlobalContext);
    const [investorFilteredText, setInvestorFilteredText] = useState('');
    const [accountFilteredText, setAccountFilteredText] = useState('');
    const [positionFilteredText, setPositionFilteredText] = useState('');
    const [fundFilteredText, setFundFilteredText] = useState('');
    const [companyFilteredText, setCompanyFilteredText] = useState('');
    const [assetFilteredText, setAssetFilteredText] = useState('');

    // const [tabSelection, setTabSelection] = useState("Investors")

    const content = (
        <div
            style={
                isPhoneSize()
                    ? {
                          height: 'calc(100vh - 230px)',
                      }
                    : {
                          height: '100vh',
                      }
            }
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'row',
                    // overflowX: "scroll",
                    overflowY: 'scroll',
                    scrollbarWidth: 'none',
                }}
            >
                <RecordManagerTab
                    text={'Investors'}
                    tabSelection={manageRecordTab}
                    setTabSelection={setManageRecordTab}
                />
                <RecordManagerTab
                    text={'Investment Entities'}
                    tabSelection={manageRecordTab}
                    setTabSelection={setManageRecordTab}
                />
                <RecordManagerTab
                    text={'Positions'}
                    tabSelection={manageRecordTab}
                    setTabSelection={setManageRecordTab}
                />
                <RecordManagerTab
                    text={'Entities/Funds'}
                    tabSelection={manageRecordTab}
                    setTabSelection={setManageRecordTab}
                />
                <RecordManagerTab
                    text={'Holding Companies'}
                    tabSelection={manageRecordTab}
                    setTabSelection={setManageRecordTab}
                />
                <RecordManagerTab
                    text={'Assets'}
                    tabSelection={manageRecordTab}
                    setTabSelection={setManageRecordTab}
                />
                <RecordManagerTab
                    text={'Portfolio Summary'}
                    tabSelection={manageRecordTab}
                    setTabSelection={setManageRecordTab}
                />
                {isAdmin() && (
                    <RecordManagerTab
                        text={'Admin'}
                        tabSelection={manageRecordTab}
                        setTabSelection={setManageRecordTab}
                    />
                )}
            </div>
            <div>
                <div style={{}}>
                    {manageRecordTab === 'Portfolio Summary' && (
                        <PortfolioSumary />
                    )}
                    {manageRecordTab === 'Investors' && (
                        <InvestorManager
                            filteredText={investorFilteredText}
                            setFilteredText={setInvestorFilteredText}
                        />
                    )}
                    {manageRecordTab === 'Investment Entities' && (
                        <AccountManager
                            filteredText={accountFilteredText}
                            setFilteredText={setAccountFilteredText}
                        />
                    )}
                    {manageRecordTab === 'Positions' && (
                        <InvestmentManager
                            filteredText={positionFilteredText}
                            setFilteredText={setPositionFilteredText}
                        />
                    )}
                    {manageRecordTab === 'Entities/Funds' && (
                        <FundManager
                            filteredText={fundFilteredText}
                            setFilteredText={setFundFilteredText}
                        />
                    )}
                    {manageRecordTab === 'Holding Companies' && (
                        <HoldingCompanyManager
                            filteredText={companyFilteredText}
                            setFilteredText={setCompanyFilteredText}
                        />
                    )}
                    {manageRecordTab === 'Assets' && (
                        <PropertyManager
                            filteredText={assetFilteredText}
                            setFilteredText={setAssetFilteredText}
                        />
                    )}
                    {manageRecordTab === 'Admin' && <Admin />}
                    {/* <div style={{ height: "150px" }}></div> */}
                </div>
            </div>
            {/* 
        
         */}
        </div>
    );

    function authorized() {
        return isAdmin() || isSale() || isVAFull();
    }

    return (
        <>
            {!authorized() && <>Not authorized</>}
            {authorized() && content}
        </>
    );
}
